import HsyIframe from '@/components/HsyIframe'

export default function PendingInvoicePage() {
  return <HsyIframe pageName={'待开发票'} />
}
import HsyIframe from '@/components/HsyIframe'

export default function PendingInvoicePage() {
  return <HsyIframe pageName={'待开发票'} />
}
